import PropTypes from "prop-types";
import styles from "./ProfileLogout1.module.css";
import { useNavigate } from "react-router";
import store from "../../Store/Store";
const ProfileLogout1 = ({ isVisible, onclose, SwitchComp, className = "" }) => {
  const navigate = useNavigate();
  const logout = () => {
    console.log("clicked");
    localStorage.removeItem("authToken");
    localStorage.removeItem("Company_Id");
    localStorage.removeItem("CompanyName");
    localStorage.removeItem("email");
    localStorage.removeItem("KycCompanyId")
    localStorage.removeItem("company_temp_id")
    store.setCompId("");
    store.setCompanyName("");
    store.setUserId("");
    navigate("/login");
  };
  if (!isVisible) return null;
  return (
    <div className={[styles.profileLogout, className].join(" ")}>
      <button className={styles.iconParent}>
        <img className={styles.icon} alt="" src="/Icon_profile.svg" />
        <div className={styles.prasanth}>{store.email.slice(0, 15)}</div>
      </button>
      <div className={styles.profileLogoutChild} />
      {store.userType === "PineLabUser" && (
        <button
          className={styles.logIn03Parent}
          onClick={() => {
            navigate("/content/kycValidation");
          }}
        >
          <img className={styles.logIn03Icon} alt="" src="/validate.svg" />
          <div className={styles.switchCompany}>KYC & validated A/c</div>
        </button>
      )}
      <button
        className={styles.logIn03Parent}
        onClick={() => {
          SwitchComp();
        }}
      >
        <img className={styles.logIn03Icon} alt="" src="/login03.svg" />
        <div className={styles.switchCompany}>Switch Brand</div>
      </button>
      <div className={styles.profileLogoutChild} />
      <button
        className={styles.logoutButtons}
        onClick={() => {
          logout();
        }}
      >
        <img
          className={styles.boxArrowRightIcon}
          alt=""
          src="/boxarrowright.svg"
        />
        <div className={styles.prasanth}>{`Logout`}</div>
      </button>
    </div>
  );
};

ProfileLogout1.propTypes = {
  className: PropTypes.string,
};

export default ProfileLogout1;
